import { useContext } from 'react';
import { IRemoteConfigFlags } from './featureFlags.types';
import FlagsContext from './FlagsContext';

export const useFlags = (): IRemoteConfigFlags => useContext(FlagsContext);
